/**
 * Types partages entre le client React et l'API Express.
 * Toute forme de donnee qui traverse le reseau est decrite ici.
 */
/*
  Le niveau du compte vit dans son propre fichier : c'est du calcul, pas
  une forme de donnee, et le script de migration s'en sert aussi.
*/
export * from './level';
/** Ce point est-il dans le territoire du spot ? Sans territoire, partout. */
export function dansLesLimites(point, limites) {
    if (!limites)
        return true;
    return (point.lat >= limites.sud &&
        point.lat <= limites.nord &&
        point.lon >= limites.ouest &&
        point.lon <= limites.est);
}
/**
 * Ou ranger une categorie neuve pour les versions qui ne la connaissent pas.
 *
 * La carte d'une ancienne version plante sur une categorie qu'elle ne sait
 * pas nommer, et un telephone Android garde son interface jusqu'a la
 * prochaine version de l'appli : des versions differentes cohabitent
 * toujours. Une sortie garde donc dans `category` une des quatre d'origine,
 * la plus proche, et sa vraie categorie a part (`categorie`). Les points et
 * le trophee « Touche-a-tout », qui lisent `category`, restent sur quatre.
 */
/**
 * Les categories qui ne se proposent que sur un serveur prive.
 *
 * « Asso » n'a de sens que la ou vivent des associations : une ecole. Sur
 * une ville ouverte a tous, elle ne se propose ni a la creation ni dans
 * les filtres. Une sortie qui la porterait deja s'y lit toujours.
 */
export const RESERVEES_AUX_PRIVES = ['asso'];
export const CATEGORIE_DE_REPLI = {
    sport: 'sport',
    culture: 'culture',
    pro: 'pro',
    food: 'food',
    asso: 'culture',
    etudes: 'pro',
    jeux: 'culture',
};
/**
 * Les langues qu'on peut parler : a une sortie, et entre membres.
 *
 * On ne scinde pas une ville par langue, ce serait diviser la seule
 * chose qui compte, le nombre de gens au meme endroit. La langue se regle
 * la ou elle fait mal : a la sortie, ou des gens qui ne se comprennent
 * pas passent une mauvaise soiree.
 *
 * Chaque langue s'ecrit dans la sienne, et porte le drapeau d'un pays ou
 * elle est chez elle : une convention pour la reconnaitre d'un coup
 * d'oeil, pas une frontiere. L'ordre du catalogue est celui dans lequel
 * les langues d'une sortie s'affichent ; la liste de choix, elle, les
 * range par ordre alphabetique.
 */
export const LANGUES_DU_MONDE = [
    { code: 'fr', nom: 'Français', drapeau: '🇫🇷' },
    { code: 'en', nom: 'English', drapeau: '🇬🇧' },
    { code: 'es', nom: 'Español', drapeau: '🇪🇸' },
    { code: 'ar', nom: 'العربية', drapeau: '🇸🇦' },
    { code: 'zh', nom: '中文', drapeau: '🇨🇳' },
    { code: 'ary', nom: 'الدارجة', drapeau: '🇲🇦' },
    { code: 'zgh', nom: 'Tamaziɣt', drapeau: '🇲🇦' },
    { code: 'de', nom: 'Deutsch', drapeau: '🇩🇪' },
    { code: 'it', nom: 'Italiano', drapeau: '🇮🇹' },
    { code: 'pt', nom: 'Português', drapeau: '🇵🇹' },
    { code: 'nl', nom: 'Nederlands', drapeau: '🇳🇱' },
    { code: 'ca', nom: 'Català', drapeau: '🇦🇩' },
    { code: 'ru', nom: 'Русский', drapeau: '🇷🇺' },
    { code: 'uk', nom: 'Українська', drapeau: '🇺🇦' },
    { code: 'pl', nom: 'Polski', drapeau: '🇵🇱' },
    { code: 'tr', nom: 'Türkçe', drapeau: '🇹🇷' },
    { code: 'el', nom: 'Ελληνικά', drapeau: '🇬🇷' },
    { code: 'sv', nom: 'Svenska', drapeau: '🇸🇪' },
    { code: 'da', nom: 'Dansk', drapeau: '🇩🇰' },
    { code: 'no', nom: 'Norsk', drapeau: '🇳🇴' },
    { code: 'fi', nom: 'Suomi', drapeau: '🇫🇮' },
    { code: 'ro', nom: 'Română', drapeau: '🇷🇴' },
    { code: 'cs', nom: 'Čeština', drapeau: '🇨🇿' },
    { code: 'hu', nom: 'Magyar', drapeau: '🇭🇺' },
    { code: 'bg', nom: 'Български', drapeau: '🇧🇬' },
    { code: 'hr', nom: 'Hrvatski', drapeau: '🇭🇷' },
    { code: 'sr', nom: 'Српски', drapeau: '🇷🇸' },
    { code: 'he', nom: 'עברית', drapeau: '🇮🇱' },
    { code: 'fa', nom: 'فارسی', drapeau: '🇮🇷' },
    { code: 'hi', nom: 'हिन्दी', drapeau: '🇮🇳' },
    { code: 'bn', nom: 'বাংলা', drapeau: '🇧🇩' },
    { code: 'ur', nom: 'اردو', drapeau: '🇵🇰' },
    { code: 'ja', nom: '日本語', drapeau: '🇯🇵' },
    { code: 'ko', nom: '한국어', drapeau: '🇰🇷' },
    { code: 'vi', nom: 'Tiếng Việt', drapeau: '🇻🇳' },
    { code: 'th', nom: 'ไทย', drapeau: '🇹🇭' },
    { code: 'id', nom: 'Bahasa Indonesia', drapeau: '🇮🇩' },
    { code: 'ms', nom: 'Bahasa Melayu', drapeau: '🇲🇾' },
    { code: 'tl', nom: 'Tagalog', drapeau: '🇵🇭' },
    { code: 'sw', nom: 'Kiswahili', drapeau: '🇰🇪' },
    { code: 'wo', nom: 'Wolof', drapeau: '🇸🇳' },
    { code: 'am', nom: 'አማርኛ', drapeau: '🇪🇹' },
];
/** Les codes seuls, dans l'ordre du catalogue. */
export const LANGUES_PARLEES = LANGUES_DU_MONDE.map((langue) => langue.code);
/* ------------------------------------------------------------------ */
/* Messages                                                            */
/* ------------------------------------------------------------------ */
/**
 * Plafond du compteur de non-lus.
 *
 * La liste des conversations ne lit que la fin de chaque fil : au-dela,
 * elle ne peut plus compter, et personne ne lit un nombre aussi grand de
 * toute facon. L'affichage le dit — « 30+ » — plutot que de donner un
 * chiffre exact qui ne le serait pas.
 */
export const UNREAD_CAP = 30;
/**
 * Le temps qu'on a pour corriger un message apres l'avoir envoye.
 *
 * Passe ce delai, la reponse de l'autre s'appuie peut-etre deja dessus :
 * changer le texte changerait le sens de la conversation apres coup. Les
 * regles de la base tiennent la meme borne (900 000 ms).
 */
export const DELAI_DE_MODIFICATION_MS = 15 * 60_000;
/** Une association, telle que la liste de l'annuaire la montre. */
/** Les familles d'associations d'une ecole, dans l'ordre ou elle les presente. */
export const CATEGORIES_D_ASSOCIATION = [
    'bde',
    'citoyennes',
    'creatives',
    'culturelles',
    'humanitaires',
    'conviviales',
    'internationales',
    'professionnelles',
    'sportives',
];
/* ------------------------------------------------------------------ */
/* Constantes partagees                                                */
/* ------------------------------------------------------------------ */
/** Longueur maximale d'un post, affichee sous le composeur. */
export const POST_MAX_LENGTH = 280;
/** Libelles francais des categories d'evenement. */
export const EVENT_CATEGORY_LABELS = {
    sport: 'Sport',
    culture: 'Culture',
    pro: 'Pro',
    food: 'Food',
    asso: 'Asso',
    etudes: 'Études',
    jeux: 'Jeux',
};
/**
 * Couleur de la barre laterale des cartes evenement.
 * Reprise telle quelle des maquettes.
 */
export const EVENT_CATEGORY_COLORS = {
    sport: '#B8451B',
    culture: '#E8933A',
    pro: '#5A5FA8',
    food: '#3F8F5B',
    asso: '#C9436E',
    etudes: '#2C7DA0',
    jeux: '#7B3FA0',
};
/** Motifs de signalement proposes dans la feuille d'actions d'un post. */
export const REPORT_REASON_LABELS = {
    spam: 'Spam',
    harassment: 'Harcèlement',
    shocking: 'Contenu choquant',
    misinformation: 'Fausse information',
    /*
      Le dernier recours : ce qui derange sans entrer dans les quatre cases.
      Sans lui, on renonce a signaler plutot que de choisir un motif faux —
      et c'est la moderation qui perd l'information.
    */
    other: 'Autre',
};
/** Motifs de l'ecran "Aide et signalements". */
export const HELP_TOPIC_LABELS = {
    member: 'Un membre',
    event: 'Un événement',
    content: 'Un post ou un message',
    bug: 'Un problème technique',
    other: 'Autre chose',
};
